<img *ngFor="let image of images" class="ya_image" [src]="image">